import PropTypes from 'prop-types';
import React from 'react';

import { QUICKSTART_TYPE_DESCRIPTIONS } from '../../../util/clientTypesHelper';
import { useTranslation } from '../../hooks/useTranslation';
import styles from '../styles.module.styl';

const CreateResource = ({ dashboardClientsUrl, dashboardApisUrl, showCreateClientMessage, currentQuickstartType }) => {
  const { t } = useTranslation('core');

  return (
    <div className={styles.textSection}>
      <p>{t('codeblockOld.header.createResource.configureSnippet', 'To configure this snippet')}</p>
      <a
        href={showCreateClientMessage ? dashboardClientsUrl : dashboardApisUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="btn btn-sm btn-transparent"
      >
        {showCreateClientMessage
          ? t('codeblockOld.header.createResource.createClient', {
              type: currentQuickstartType ? QUICKSTART_TYPE_DESCRIPTIONS[currentQuickstartType] : 'an Application',
            })
          : t('codeblockOld.header.createResource.createApi', 'Create an API')}
      </a>
    </div>
  );
};

CreateResource.contextTypes = {
  executeAction: PropTypes.func,
};

CreateResource.propTypes = {
  dashboardClientsUrl: PropTypes.string.isRequired,
  dashboardApisUrl: PropTypes.string.isRequired,
  showCreateClientMessage: PropTypes.bool,
  currentQuickstartType: PropTypes.string,
};

export default CreateResource;
